import React from 'react';
import { motion } from 'framer-motion';
import { AnimatedSection } from './AnimatedSection';
import { BrainIcon, ThermometerIcon, ShieldCheckIcon } from 'lucide-react';
export function MechanismSection() {
  return <AnimatedSection className="py-16 md:py-24 px-4 sm:px-6" data-id="element-93">
      <div className="max-w-4xl mx-auto" data-id="element-94">
        <h2 className="font-display text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-4 text-center" data-id="element-95">
          El Mecanismo Único:{' '}
          <span className="text-[#4ECDC4]" data-id="element-96">Sinergia Glicina-Magnesio</span>
        </h2>

        <div className="mt-12 glass-card rounded-2xl p-8 md:p-12 relative overflow-hidden" data-id="element-97">
          {/* Decorative glow */}
          <div className="absolute -top-20 -right-20 w-40 h-40 bg-[#4ECDC4] rounded-full opacity-10 blur-3xl" data-id="element-98" />
          <div className="absolute -bottom-20 -left-20 w-40 h-40 bg-[#D4A853] rounded-full opacity-10 blur-3xl" data-id="element-99" />

          <p className="text-gray-300 text-base md:text-lg leading-relaxed mb-10 relative z-10" data-id="element-100">
            A diferencia de otras formas, el{' '}
            <strong className="text-white" data-id="element-101">Glicinato de Magnesio</strong> cruza
            la barrera hematoencefálica y utiliza el aminoácido{' '}
            <strong className="text-[#4ECDC4]" data-id="element-102">Glicina</strong> para reducir tu
            temperatura corporal central — la señal biológica maestra que le
            dice a tu cerebro:{' '}
            <em className="text-[#D4A853] font-display text-xl" data-id="element-103">
              "Es seguro dormir"
            </em>
            .
          </p>

          <div className="grid sm:grid-cols-3 gap-6 relative z-10" data-id="element-104">
            {[{
            icon: BrainIcon,
            label: 'Cruza la barrera hematoencefálica',
            color: '#4ECDC4'
          }, {
            icon: ThermometerIcon,
            label: 'Reduce la temperatura corporal',
            color: '#D4A853'
          }, {
            icon: ShieldCheckIcon,
            label: 'Señal biológica de seguridad',
            color: '#4ECDC4'
          }].map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: i * 0.15
          }} className="text-center" data-id="element-105">
                <div className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-3" style={{
              background: `${item.color}15`,
              border: `1px solid ${item.color}30`
            }} data-id="element-106">
                  <item.icon className="w-7 h-7" style={{
                color: item.color
              }} data-id="element-107" />
                </div>
                <p className="text-sm text-gray-300 font-medium" data-id="element-108">
                  {item.label}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </AnimatedSection>;
}